/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './cost-of-living.component.scss.ngstyle';
import * as import1 from './page-slide.scss.ngstyle';
import * as import2 from './leaflet.scss.ngstyle';
import * as import3 from './nouislider.scss.ngstyle';
import * as import4 from '@angular/core';
import * as import5 from '@angular/common';
import * as import6 from '@angular/forms';
import * as import7 from '../../node_modules/ng2-nouislider/src/nouislider.ngfactory';
import * as import8 from 'ng2-nouislider/src/nouislider';
import * as import9 from '../../../app/shared/pipes/key-pipe';
import * as import10 from '../../../app/cost-of-living/cost-of-living.component';
import * as import11 from '@angular/router';
import * as import12 from '../../../modules/transfer-state/transfer-state';
import * as import13 from '../../../../common/utils/cityutils';
import * as import14 from '../../../../common/utils/mapurlutils';
import * as import15 from '../../../../common/utils/professioncategoriesutils';
import * as import16 from '../../../../common/utils/affordabilityutils';
import * as import17 from '../../../../common/utils/censustractstilesutils';
const styles_CostOfLivingComponent:any[] = [
  import0.styles,
  import1.styles,
  import2.styles,
  import3.styles
]
;
export const RenderType_CostOfLivingComponent:import4.RendererType2 = import4.ɵcrt({
  encapsulation: 2,
  styles: styles_CostOfLivingComponent,
  data: {}
}
);
function View_CostOfLivingComponent_1(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setCity(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                    ',
      ', ',
      '\n                  '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    const currVal_1:any = v.context.$implicit.state.code;
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_CostOfLivingComponent_3(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'profession-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                      ',
      '\n                  '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.profile.firstProfession.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_4(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'span',[[
        'class',
        'profession-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                      ',
      ' ',
      '\n                  '
    ]
    )),
    import4.ɵppd(4)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.profile.firstProfession.name;
    const currVal_1:any = import4.ɵunv(v,1,1,ck(v,2,0,import4.ɵnov((<any>(<any>v.parent).parent),0),co.profile.firstProfessionIncome,'USD',true,'1.0'));
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_CostOfLivingComponent_6(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),7,'ul',[
      [
        'class',
        'option-group-list'
      ]
      ,
      [
        'style',
        'display:none;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setFirstProfession(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                                ',
      '\n                              '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                            '])),
    (l()(),import4.ɵted((null as any),['\n                          ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,5,0,currVal_0);
  });
}
function View_CostOfLivingComponent_5(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),13,'li',[[
        'class',
        'option-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n                      '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),10,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',[[
        'class',
        'option-group-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_6)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵted((null as any),['\n                      '])),
    (l()(),import4.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit.professions;
    ck(v,10,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,5,0,currVal_0);
  });
}
function View_CostOfLivingComponent_7(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'profession-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                      ',
      '\n                  '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.profile.secondProfession.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_8(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'span',[[
        'class',
        'profession-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                      ',
      ' ',
      '\n                  '
    ]
    )),
    import4.ɵppd(4)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.profile.secondProfession.name;
    const currVal_1:any = import4.ɵunv(v,1,1,ck(v,2,0,import4.ɵnov((<any>(<any>v.parent).parent),0),co.profile.secondProfessionIncome,'USD',true,'1.0'));
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_CostOfLivingComponent_10(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),7,'ul',[
      [
        'class',
        'option-group-list'
      ]
      ,
      [
        'style',
        'display:none;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setSecondProfession(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                                ',
      '\n                              '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                            '])),
    (l()(),import4.ɵted((null as any),['\n                          ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,5,0,currVal_0);
  });
}
function View_CostOfLivingComponent_9(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),13,'li',[[
        'class',
        'option-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),10,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',[[
        'class',
        'option-group-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_10)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵted((null as any),['\n                      '])),
    (l()(),import4.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit.professions;
    ck(v,10,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,5,0,currVal_0);
  });
}
function View_CostOfLivingComponent_11(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[(l()(),import4.ɵted((null as any),['person']))],(null as any),(null as any));
}
function View_CostOfLivingComponent_12(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[(l()(),import4.ɵted((null as any),['people']))],(null as any),(null as any));
}
function View_CostOfLivingComponent_14(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['You']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_16(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import4.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import4.ElementRef,
      import4.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import4.ɵdid(147456,(null as any),0,import6.ɵq,[
      import4.ElementRef,
      import4.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),[
      '',
      ' y.o.'
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit,'');
    ck(v,1,0,currVal_0);
    const currVal_1:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit,'');
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = v.context.$implicit;
    ck(v,3,0,currVal_2);
  });
}
function View_CostOfLivingComponent_15(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),9,'select',[[
        'class',
        'age-select form-control'
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,1).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,1).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>((<any>v.parent).context.$implicit.age = $event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('change' === en)) {
        const pd_3:any = ((<any>co.updateMember()) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef
    ]
    ,(null as any),(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n                          '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_16)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = (<any>v.parent).context.$implicit.age;
    ck(v,3,0,currVal_7);
    const currVal_8:any = co.youAgeRange;
    ck(v,8,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import4.ɵnov(v,5).ngClassUntouched;
    const currVal_1:any = import4.ɵnov(v,5).ngClassTouched;
    const currVal_2:any = import4.ɵnov(v,5).ngClassPristine;
    const currVal_3:any = import4.ɵnov(v,5).ngClassDirty;
    const currVal_4:any = import4.ɵnov(v,5).ngClassValid;
    const currVal_5:any = import4.ɵnov(v,5).ngClassInvalid;
    const currVal_6:any = import4.ɵnov(v,5).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CostOfLivingComponent_18(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import4.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import4.ElementRef,
      import4.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import4.ɵdid(147456,(null as any),0,import6.ɵq,[
      import4.ElementRef,
      import4.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),[
      '',
      ' y.o.'
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit,'');
    ck(v,1,0,currVal_0);
    const currVal_1:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit,'');
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = v.context.$implicit;
    ck(v,3,0,currVal_2);
  });
}
function View_CostOfLivingComponent_17(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),9,'select',[[
        'class',
        'age-select form-control'
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,1).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,1).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>((<any>v.parent).context.$implicit.age = $event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('change' === en)) {
        const pd_3:any = ((<any>co.updateMember()) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef
    ]
    ,(null as any),(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n                          '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_18)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = (<any>v.parent).context.$implicit.age;
    ck(v,3,0,currVal_7);
    const currVal_8:any = co.ageRange;
    ck(v,8,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import4.ɵnov(v,5).ngClassUntouched;
    const currVal_1:any = import4.ɵnov(v,5).ngClassTouched;
    const currVal_2:any = import4.ɵnov(v,5).ngClassPristine;
    const currVal_3:any = import4.ɵnov(v,5).ngClassDirty;
    const currVal_4:any = import4.ɵnov(v,5).ngClassValid;
    const currVal_5:any = import4.ɵnov(v,5).ngClassInvalid;
    const currVal_6:any = import4.ɵnov(v,5).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CostOfLivingComponent_19(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'i',[
      [
        'class',
        'icon-remove delete-member-button'
      ]
      ,
      [
        'title',
        'delete'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.removeMember((<any>v.parent).context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['x']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_13(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),36,'div',[[
        'class',
        'member-item default-item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'label',[[
        'class',
        'age-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_14)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_15)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_17)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),9,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'type',
        'radio'
      ]
      ,
      [
        'value',
        'M'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,15)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,15).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import4.ɵnov(v,15)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import4.ɵnov(v,15)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import4.ɵnov(v,16).onChange()) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>import4.ɵnov(v,16).onTouched()) !== false);
        ad = (pd_5 && ad);
      }
      if (('change' === en)) {
        const pd_6:any = ((<any>co.updateMember()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(v.context.$implicit.gender = $event)) !== false);
        ad = (pd_7 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import4.ɵdid(212992,(null as any),0,import6.RadioControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      import6.ɵi,
      import4.Injector
    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      value: [
        1,
        'value'
      ]

    }
    ,(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import6.DefaultValueAccessor,
      import6.RadioControlValueAccessor
    ]
    ),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n                          Male\n                        '])),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),9,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'type',
        'radio'
      ]
      ,
      [
        'value',
        'F'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,26)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,26).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import4.ɵnov(v,26)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import4.ɵnov(v,26)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import4.ɵnov(v,27).onChange()) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>import4.ɵnov(v,27).onTouched()) !== false);
        ad = (pd_5 && ad);
      }
      if (('change' === en)) {
        const pd_6:any = ((<any>co.updateMember()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(v.context.$implicit.gender = $event)) !== false);
        ad = (pd_7 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import4.ɵdid(212992,(null as any),0,import6.RadioControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      import6.ɵi,
      import4.Injector
    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      value: [
        1,
        'value'
      ]

    }
    ,(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import6.DefaultValueAccessor,
      import6.RadioControlValueAccessor
    ]
    ),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n                          Female\n                        '])),
    (l()(),import4.ɵted((null as any),['\n                        '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_19)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                      ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.first;
    ck(v,4,0,currVal_0);
    const currVal_1:any = v.context.first;
    ck(v,7,0,currVal_1);
    const currVal_2:boolean = !v.context.first;
    ck(v,10,0,currVal_2);
    const currVal_10:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_11:any = 'M';
    ck(v,16,0,currVal_10,currVal_11);
    const currVal_12:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_13:any = v.context.$implicit.gender;
    ck(v,18,0,currVal_12,currVal_13);
    const currVal_21:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_22:any = 'F';
    ck(v,27,0,currVal_21,currVal_22);
    const currVal_23:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_24:any = v.context.$implicit.gender;
    ck(v,29,0,currVal_23,currVal_24);
    const currVal_25:boolean = !v.context.first;
    ck(v,35,0,currVal_25);
  },(ck,v) => {
    const currVal_3:any = import4.ɵnov(v,20).ngClassUntouched;
    const currVal_4:any = import4.ɵnov(v,20).ngClassTouched;
    const currVal_5:any = import4.ɵnov(v,20).ngClassPristine;
    const currVal_6:any = import4.ɵnov(v,20).ngClassDirty;
    const currVal_7:any = import4.ɵnov(v,20).ngClassValid;
    const currVal_8:any = import4.ɵnov(v,20).ngClassInvalid;
    const currVal_9:any = import4.ɵnov(v,20).ngClassPending;
    ck(v,14,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_14:any = import4.ɵnov(v,31).ngClassUntouched;
    const currVal_15:any = import4.ɵnov(v,31).ngClassTouched;
    const currVal_16:any = import4.ɵnov(v,31).ngClassPristine;
    const currVal_17:any = import4.ɵnov(v,31).ngClassDirty;
    const currVal_18:any = import4.ɵnov(v,31).ngClassValid;
    const currVal_19:any = import4.ɵnov(v,31).ngClassInvalid;
    const currVal_20:any = import4.ɵnov(v,31).ngClassPending;
    ck(v,25,0,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20);
  });
}
function View_CostOfLivingComponent_20(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'add-member-btn pull-right'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.addMember('M')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['+ add member']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_21(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setFoodPlan(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                      ',
      '\n                    '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                  ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
  });
}
function View_CostOfLivingComponent_2(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),231,'div',[[
        'id',
        'custom-profile-controls'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),228,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),55,'div',[[
        'class',
        'config-control profession-control'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'config-control-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['First profession'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),49,'div',[[
        'class',
        'config-control-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),46,'div',[[
        'class',
        'dropdown dropdown-professions first-profession'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),9,'button',[
      [
        'aria-expanded',
        'false'
      ]
      ,
      [
        'aria-haspopup',
        'true'
      ]
      ,
      [
        'class',
        'btn btn-default dropdown-toggle'
      ]
      ,
      [
        'data-toggle',
        'dropdown'
      ]
      ,
      [
        'id',
        'first_profession'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_3)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_4)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'b',[[
        'class',
        'caret'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),32,'div',[
      [
        'aria-labelledby',
        'dLabel'
      ]
      ,
      [
        'class',
        'dropdown-menu'
      ]
      ,
      [
        'role',
        'menu'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n                  '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),29,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option default-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setFirstProfession(co.specialProfessions.AVERAGE_INCOME)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        ',
      '\n                      '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setFirstProfession(co.specialProfessions.MINIMUM_WAGE)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        ',
      '\n                      '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n\n                    '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_5)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'li',[[
        'class',
        'custom-income'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),8,'span',[[
        'class',
        'form-inline'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          ... or enter income $ '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'custom-income-input form-control'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
      ,[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-secondary btn-xs'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setCustomIncome($event,co.specialProfessions.FIRST_CUSTOM_INCOME)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                              Ok\n                          '])),
    (l()(),import4.ɵted((null as any),['\n                          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'error custom-income-error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n\n                  '])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),67,'div',[[
        'class',
        'config-control profession-control'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'config-control-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Second profession'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),61,'div',[[
        'class',
        'config-control-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),58,'div',[[
        'class',
        'dropdown dropdown-professions second-profession'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),9,'button',[
      [
        'aria-expanded',
        'false'
      ]
      ,
      [
        'aria-haspopup',
        'true'
      ]
      ,
      [
        'class',
        'btn btn-default dropdown-toggle'
      ]
      ,
      [
        'data-toggle',
        'dropdown'
      ]
      ,
      [
        'id',
        'second_profession'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_7)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_8)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'b',[[
        'class',
        'caret'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),44,'div',[
      [
        'aria-labelledby',
        'dLabel'
      ]
      ,
      [
        'class',
        'dropdown-menu'
      ]
      ,
      [
        'role',
        'menu'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n                  '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),41,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option default-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setSecondProfession(co.specialProfessions.NO_SPOUSE)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        ',
      '\n                      '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setSecondProfession(co.specialProfessions.AVERAGE_INCOME)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        ',
      '\n                      '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setSecondProfession(co.specialProfessions.STAY_AT_HOME)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        ',
      '\n                      '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'select-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setSecondProfession(co.specialProfessions.MINIMUM_WAGE)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        ',
      '\n                      '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n\n                    '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_9)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'li',[[
        'class',
        'custom-income'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),8,'span',[[
        'class',
        'form-inline'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          ... or enter income $ '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'custom-income-input form-control'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
      ,[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-secondary btn-xs'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setCustomIncome($event,co.specialProfessions.SECOND_CUSTOM_INCOME)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                              Ok\n                          '])),
    (l()(),import4.ɵted((null as any),['\n                          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'error custom-income-error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),45,'div',[[
        'class',
        'config-control household-members-control'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'config-control-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Family'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),39,'div',[[
        'class',
        'config-control-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),36,'div',[[
        'class',
        'dropdown dropdown-household-members'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),13,'button',[
      [
        'aria-expanded',
        'false'
      ]
      ,
      [
        'aria-haspopup',
        'true'
      ]
      ,
      [
        'class',
        'btn btn-default dropdown-toggle'
      ]
      ,
      [
        'data-toggle',
        'dropdown'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),8,'span',[
      [
        'class',
        'members-size'
      ]
      ,
      [
        'i18n',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                    ',
      ' '
    ]
    )),
    (l()(),import4.ɵeld(0,(null as any),(null as any),5,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      import4.ɵdid(16384,(null as any),0,import5.NgSwitch,([] as any[]),{ngSwitch: [
        0,
        'ngSwitch'
      ]
    },(null as any)),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_11)),
    import4.ɵdid(278528,(null as any),0,import5.NgSwitchCase,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import5.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_12)),
    import4.ɵdid(16384,(null as any),0,import5.NgSwitchDefault,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import5.NgSwitch
    ]
    ,(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),[' in house\n                  '])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'b',[[
        'class',
        'caret'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),18,'div',[
      [
        'aria-labelledby',
        'dLabel'
      ]
      ,
      [
        'class',
        'dropdown-menu'
      ]
      ,
      [
        'role',
        'menu'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'household-members-editor'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'members-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_13)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'style',
        'text-align:right;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                      '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_20)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵted((null as any),['\n                    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),16,'div',[
      [
        'class',
        'config-control house-area-control'
      ]
      ,
      [
        'style',
        'padding-right: 20px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'config-control-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Rent'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),10,'div',[
      [
        'class',
        'config-control-options'
      ]
      ,
      [
        'style',
        'white-space: nowrap;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'slider-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),5,'nouislider',([] as any[]),[
      [
        2,
        'ng2-nouislider',
        (null as any)
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'slide'
      ]
      ,
      [
        (null as any),
        'end'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.profile.houseRentArea = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('slide' === en)) {
        const pd_1:any = ((<any>co.setSliderTooltip($event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('end' === en)) {
        const pd_2:any = ((<any>co.sliderEnd()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import7.View_NouisliderComponent_0,import7.RenderType_NouisliderComponent)),
    import4.ɵdid(638976,(null as any),0,import8.NouisliderComponent,[import4.ElementRef],{
      connect: [
        0,
        'connect'
      ]
      ,
      min: [
        1,
        'min'
      ]
      ,
      max: [
        2,
        'max'
      ]
      ,
      step: [
        3,
        'step'
      ]
      ,
      ngModel: [
        4,
        'ngModel'
      ]

    }
    ,{
      slide: 'slide',
      end: 'end'
    }
    ),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import8.NouisliderComponent]),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      ' sq.ft.\n            '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'config-control food-plan-control'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'config-control-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Food plan'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'config-control-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'dropdown dropdown-food-plan'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),6,'button',[
      [
        'aria-expanded',
        'false'
      ]
      ,
      [
        'aria-haspopup',
        'true'
      ]
      ,
      [
        'class',
        'btn btn-default dropdown-toggle'
      ]
      ,
      [
        'data-toggle',
        'dropdown'
      ]
      ,
      [
        'id',
        'food_plan'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'food-plan-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'b',[[
        'class',
        'caret'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),4,'ul',[
      [
        'aria-labelledby',
        'dLabel'
      ]
      ,
      [
        'class',
        'dropdown-menu'
      ]
      ,
      [
        'role',
        'menu'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_21)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n        '])),
    (l()(),import4.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.profile.firstProfession.code !== co.specialProfessions.FIRST_CUSTOM_INCOME.code);
    ck(v,17,0,currVal_0);
    const currVal_1:any = (co.profile.firstProfession.code === co.specialProfessions.FIRST_CUSTOM_INCOME.code);
    ck(v,20,0,currVal_1);
    const currVal_4:any = co.professions;
    ck(v,42,0,currVal_4);
    const currVal_6:any = (co.profile.secondProfession.code !== co.specialProfessions.SECOND_CUSTOM_INCOME.code);
    ck(v,76,0,currVal_6);
    const currVal_7:any = (co.profile.secondProfession.code === co.specialProfessions.SECOND_CUSTOM_INCOME.code);
    ck(v,79,0,currVal_7);
    const currVal_12:any = co.professions;
    ck(v,113,0,currVal_12);
    const currVal_15:any = co.profile.householdMembers.length;
    ck(v,149,0,currVal_15);
    const currVal_16:any = '=1';
    ck(v,151,0,currVal_16);
    const currVal_17:any = co.profile.householdMembers;
    ck(v,166,0,currVal_17);
    const currVal_18:any = (co.profile.householdMembers.length < 6);
    ck(v,172,0,currVal_18);
    const currVal_27:any = true;
    const currVal_28:any = co.slider.min;
    const currVal_29:any = co.slider.max;
    const currVal_30:any = 1;
    const currVal_31:any = co.profile.houseRentArea;
    ck(v,193,0,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31);
    const currVal_32:any = co.profile.houseRentArea;
    ck(v,195,0,currVal_32);
    const currVal_35:any = co.foodPlans;
    ck(v,224,0,currVal_35);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.specialProfessions.AVERAGE_INCOME.name;
    ck(v,32,0,currVal_2);
    const currVal_3:any = co.specialProfessions.MINIMUM_WAGE.name;
    ck(v,38,0,currVal_3);
    const currVal_5:any = import4.ɵinlineInterpolate(1,'',co.profile.firstProfessionIncome,'');
    ck(v,48,0,currVal_5);
    const currVal_8:any = co.specialProfessions.NO_SPOUSE.name;
    ck(v,91,0,currVal_8);
    const currVal_9:any = co.specialProfessions.AVERAGE_INCOME.name;
    ck(v,97,0,currVal_9);
    const currVal_10:any = co.specialProfessions.STAY_AT_HOME.name;
    ck(v,103,0,currVal_10);
    const currVal_11:any = co.specialProfessions.MINIMUM_WAGE.name;
    ck(v,109,0,currVal_11);
    const currVal_13:any = import4.ɵinlineInterpolate(1,'',co.profile.secondProfessionIncome,'');
    ck(v,119,0,currVal_13);
    const currVal_14:any = co.profile.householdMembers.length;
    ck(v,147,0,currVal_14);
    const currVal_19:any = true;
    const currVal_20:any = import4.ɵnov(v,197).ngClassUntouched;
    const currVal_21:any = import4.ɵnov(v,197).ngClassTouched;
    const currVal_22:any = import4.ɵnov(v,197).ngClassPristine;
    const currVal_23:any = import4.ɵnov(v,197).ngClassDirty;
    const currVal_24:any = import4.ɵnov(v,197).ngClassValid;
    const currVal_25:any = import4.ɵnov(v,197).ngClassInvalid;
    const currVal_26:any = import4.ɵnov(v,197).ngClassPending;
    ck(v,192,0,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26);
    const currVal_33:any = co.slider.value;
    ck(v,199,0,currVal_33);
    const currVal_34:any = co.profile.foodPlan.name;
    ck(v,216,0,currVal_34);
  });
}
function View_CostOfLivingComponent_22(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Income']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = import4.ɵinlineInterpolate(1,'',(((tmp_0_0 = import4.ɵunv(v,2,0,import4.ɵnov(v,3).transform(co.censusTract))) == null)? (null as any): tmp_0_0.properties.incomeSourceLink),'');
    ck(v,2,0,currVal_0);
  });
}
function View_CostOfLivingComponent_23(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Income']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_24(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.setCity(v.context.$implicit);
        const pd_0:any = ((<any>co.toggleScreen('.map-location-selector','left')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      ', ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    const currVal_1:any = v.context.$implicit.state.code;
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_CostOfLivingComponent_25(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-profile-selector','left');
        const pd_0:any = ((<any>co.setProfile(v.context.$implicit.value.id)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.value.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_26(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        : ',
      '\n                    '
    ]
    )),
    import4.ɵppd(4)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import4.ɵunv(v,1,0,ck(v,2,0,import4.ɵnov((<any>v.parent),0),co.profile.firstProfessionIncome,'USD',true,'1.0'));
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_27(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                        : ',
      '\n                    '
    ]
    )),
    import4.ɵppd(4)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import4.ɵunv(v,1,0,ck(v,2,0,import4.ɵnov((<any>v.parent),0),co.profile.secondProfessionIncome,'USD',true,'1.0'));
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_28(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[(l()(),import4.ɵted((null as any),['person']))],(null as any),(null as any));
}
function View_CostOfLivingComponent_29(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[(l()(),import4.ɵted((null as any),['people']))],(null as any),(null as any));
}
function View_CostOfLivingComponent_30(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Your occupation']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_31(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Spouse occupation']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_32(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-settings.profession','right');
        const pd_0:any = ((<any>co.setProfession(co.specialProfessions.NO_SPOUSE)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.specialProfessions.NO_SPOUSE.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_33(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-settings.profession','right');
        const pd_0:any = ((<any>co.setProfession(co.specialProfessions.STAY_AT_HOME)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.specialProfessions.STAY_AT_HOME.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_35(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-settings.profession','right');
        const pd_0:any = ((<any>co.setProfession(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                  ',
      '\n                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_34(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'option-group'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleProfessionCategory($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option option-group-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'option-group-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_35)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit.professions;
    ck(v,8,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
  });
}
function View_CostOfLivingComponent_36(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-default'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.setCustomIncome($event,co.specialProfessions.FIRST_CUSTOM_INCOME);
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.profession','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Ok']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_37(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-default'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.setCustomIncome($event,co.specialProfessions.SECOND_CUSTOM_INCOME);
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.profession','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Ok']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_38(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-right'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.addMember()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-plus fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          ']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_40(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'you'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['You']))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_42(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import4.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import4.ElementRef,
      import4.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import4.ɵdid(147456,(null as any),0,import6.ɵq,[
      import4.ElementRef,
      import4.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),[
      '',
      ' y.o.'
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import4.ɵinlineInterpolate(1,'',co.i,'');
    ck(v,1,0,currVal_0);
    const currVal_1:any = import4.ɵinlineInterpolate(1,'',co.i,'');
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.i;
    ck(v,3,0,currVal_2);
  });
}
function View_CostOfLivingComponent_41(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),9,'select',([] as any[]),[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,1).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,1).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>((<any>v.parent).context.$implicit.age = $event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('change' === en)) {
        const pd_3:any = ((<any>co.updateMember()) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef
    ]
    ,(null as any),(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_42)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = (<any>v.parent).context.$implicit.age;
    ck(v,3,0,currVal_7);
    const currVal_8:any = co.youAgeRange;
    ck(v,8,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import4.ɵnov(v,5).ngClassUntouched;
    const currVal_1:any = import4.ɵnov(v,5).ngClassTouched;
    const currVal_2:any = import4.ɵnov(v,5).ngClassPristine;
    const currVal_3:any = import4.ɵnov(v,5).ngClassDirty;
    const currVal_4:any = import4.ɵnov(v,5).ngClassValid;
    const currVal_5:any = import4.ɵnov(v,5).ngClassInvalid;
    const currVal_6:any = import4.ɵnov(v,5).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CostOfLivingComponent_44(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import4.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import4.ElementRef,
      import4.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import4.ɵdid(147456,(null as any),0,import6.ɵq,[
      import4.ElementRef,
      import4.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),[
      '',
      ' y.o.'
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import4.ɵinlineInterpolate(1,'',co.i,'');
    ck(v,1,0,currVal_0);
    const currVal_1:any = import4.ɵinlineInterpolate(1,'',co.i,'');
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.i;
    ck(v,3,0,currVal_2);
  });
}
function View_CostOfLivingComponent_43(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),9,'select',([] as any[]),[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,1).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,1).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>((<any>v.parent).context.$implicit.age = $event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('change' === en)) {
        const pd_3:any = ((<any>co.updateMember()) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef
    ]
    ,(null as any),(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_44)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = (<any>v.parent).context.$implicit.age;
    ck(v,3,0,currVal_7);
    const currVal_8:any = co.ageRange;
    ck(v,8,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import4.ɵnov(v,5).ngClassUntouched;
    const currVal_1:any = import4.ɵnov(v,5).ngClassTouched;
    const currVal_2:any = import4.ɵnov(v,5).ngClassPristine;
    const currVal_3:any = import4.ɵnov(v,5).ngClassDirty;
    const currVal_4:any = import4.ɵnov(v,5).ngClassValid;
    const currVal_5:any = import4.ɵnov(v,5).ngClassInvalid;
    const currVal_6:any = import4.ɵnov(v,5).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CostOfLivingComponent_45(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'btn-delete'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.removeMember((<any>v.parent).context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-minus-square fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(null as any),(null as any));
}
function View_CostOfLivingComponent_39(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),41,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import4.ɵdid(278528,(null as any),0,import5.NgClass,[
      import4.IterableDiffers,
      import4.KeyValueDiffers,
      import4.ElementRef,
      import4.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import4.ɵpod([
      'member',
      'household'
    ]
    ),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_40)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_41)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_43)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'label',[[
        'class',
        'gender'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-male fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[' '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'type',
        'radio'
      ]
      ,
      [
        'value',
        'M'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,18)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,18).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import4.ɵnov(v,18)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import4.ɵnov(v,18)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import4.ɵnov(v,19).onChange()) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>import4.ɵnov(v,19).onTouched()) !== false);
        ad = (pd_5 && ad);
      }
      if (('change' === en)) {
        const pd_6:any = ((<any>co.updateMember()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(v.context.$implicit.gender = $event)) !== false);
        ad = (pd_7 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import4.ɵdid(212992,(null as any),0,import6.RadioControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      import6.ɵi,
      import4.Injector
    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      value: [
        1,
        'value'
      ]

    }
    ,(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import6.DefaultValueAccessor,
      import6.RadioControlValueAccessor
    ]
    ),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'label',[[
        'class',
        'gender'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-female fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[' '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'type',
        'radio'
      ]
      ,
      [
        'value',
        'F'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import4.ɵnov(v,31)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import4.ɵnov(v,31).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import4.ɵnov(v,31)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import4.ɵnov(v,31)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import4.ɵnov(v,32).onChange()) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>import4.ɵnov(v,32).onTouched()) !== false);
        ad = (pd_5 && ad);
      }
      if (('change' === en)) {
        const pd_6:any = ((<any>co.updateMember()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(v.context.$implicit.gender = $event)) !== false);
        ad = (pd_7 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import4.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import4.ɵdid(212992,(null as any),0,import6.RadioControlValueAccessor,[
      import4.Renderer,
      import4.ElementRef,
      import6.ɵi,
      import4.Injector
    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      value: [
        1,
        'value'
      ]

    }
    ,(null as any)),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import6.DefaultValueAccessor,
      import6.RadioControlValueAccessor
    ]
    ),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_45)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ck(v,2,0,true,v.context.first);
    ck(v,1,0,currVal_0);
    const currVal_1:any = v.context.first;
    ck(v,5,0,currVal_1);
    const currVal_2:any = v.context.first;
    ck(v,8,0,currVal_2);
    const currVal_3:boolean = !v.context.first;
    ck(v,11,0,currVal_3);
    const currVal_11:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_12:any = 'M';
    ck(v,19,0,currVal_11,currVal_12);
    const currVal_13:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_14:any = v.context.$implicit.gender;
    ck(v,21,0,currVal_13,currVal_14);
    const currVal_22:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_23:any = 'F';
    ck(v,32,0,currVal_22,currVal_23);
    const currVal_24:any = import4.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_gender');
    const currVal_25:any = v.context.$implicit.gender;
    ck(v,34,0,currVal_24,currVal_25);
    const currVal_26:boolean = !v.context.first;
    ck(v,40,0,currVal_26);
  },(ck,v) => {
    const currVal_4:any = import4.ɵnov(v,23).ngClassUntouched;
    const currVal_5:any = import4.ɵnov(v,23).ngClassTouched;
    const currVal_6:any = import4.ɵnov(v,23).ngClassPristine;
    const currVal_7:any = import4.ɵnov(v,23).ngClassDirty;
    const currVal_8:any = import4.ɵnov(v,23).ngClassValid;
    const currVal_9:any = import4.ɵnov(v,23).ngClassInvalid;
    const currVal_10:any = import4.ɵnov(v,23).ngClassPending;
    ck(v,17,0,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
    const currVal_15:any = import4.ɵnov(v,36).ngClassUntouched;
    const currVal_16:any = import4.ɵnov(v,36).ngClassTouched;
    const currVal_17:any = import4.ɵnov(v,36).ngClassPristine;
    const currVal_18:any = import4.ɵnov(v,36).ngClassDirty;
    const currVal_19:any = import4.ɵnov(v,36).ngClassValid;
    const currVal_20:any = import4.ɵnov(v,36).ngClassInvalid;
    const currVal_21:any = import4.ɵnov(v,36).ngClassPending;
    ck(v,30,0,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21);
  });
}
function View_CostOfLivingComponent_46(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-settings.food','right');
        const pd_0:any = ((<any>co.setFoodPlan(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CostOfLivingComponent_47(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Income']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = import4.ɵinlineInterpolate(1,'',(((tmp_0_0 = import4.ɵunv(v,2,0,import4.ɵnov(v,3).transform(co.censusTract))) == null)? (null as any): tmp_0_0.properties.incomeSourceLink),'');
    ck(v,2,0,currVal_0);
  });
}
function View_CostOfLivingComponent_48(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Income']))
  ]
  ,(null as any),(null as any));
}
export function View_CostOfLivingComponent_0(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    import4.ɵpid(0,import5.CurrencyPipe,[import4.LOCALE_ID]),
    import4.ɵpid(0,import9.KeysPipe,([] as any[])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),789,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'map-header hidden-lg-up'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'col-10'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'location'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-location-selector','left')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ', ',
      ''
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'profile'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-profile-selector','left')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n    '])),
    (l()(),import4.ɵted((null as any),['\n  '])),
    (l()(),import4.ɵted((null as any),['\n\n  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),764,'div',[[
        'class',
        'affordability-map-container content-wrap'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),81,'div',[[
        'class',
        'map-header hidden-md-down'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),75,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),72,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),69,'h1',[[
        'class',
        'map-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'map-title-prefix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Cost of Living in'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'dropdown dd-location'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'button',[
      [
        'aria-expanded',
        'false'
      ]
      ,
      [
        'aria-haspopup',
        'true'
      ]
      ,
      [
        'class',
        'dropdown-toggle'
      ]
      ,
      [
        'data-toggle',
        'dropdown'
      ]
      ,
      [
        'id',
        'locationDDButton'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                ',
      ', ',
      '\n              '
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),7,'div',[
      [
        'aria-labelledby',
        'locationDDButton'
      ]
      ,
      [
        'class',
        'dropdown-menu'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),4,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_1)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'map-title-prefix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[' for '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),40,'div',[[
        'class',
        'dropdown dd-profile'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'aria-expanded',
        'false'
      ]
      ,
      [
        'aria-haspopup',
        'true'
      ]
      ,
      [
        'class',
        'dropdown-toggle'
      ]
      ,
      [
        'data-toggle',
        'dropdown'
      ]
      ,
      [
        'id',
        'profileDDButton'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n                ',
      '\n              '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),34,'div',[
      [
        'aria-labelledby',
        'profileDDButton'
      ]
      ,
      [
        'class',
        'dropdown-menu'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),31,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',[[
        'class',
        'selected'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('at_home_mom_household')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Stay-at-Home Mom'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('highly_educated_workaholics')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Workaholics'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('middle_class_couple')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Middle Class Couples'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('minimum_wage')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Minimum Wage'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('single_freelancer')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Single Freelancers'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('upper_middle_class_family_with_kids')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Upper Middle Class'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('working_class_family_of_4')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Working Class'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('young_family_in_fast_growing_careers')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Young Families'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('young_worker_cashier')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Young Workers'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('custom_household')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Custom Household'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[
      [
        'class',
        'map-title-suffix'
      ]
      ,
      [
        'id',
        'custom-profile-selector'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setProfile('custom_household')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-cog'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_2)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n\n    '])),
    (l()(),import4.ɵted((null as any),['\n\n    '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[
      [
        'class',
        'leaflet-map'
      ]
      ,
      [
        'id',
        'map'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),450,'div',[[
        'class',
        'mobile-content hidden-lg-up'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn btn-open-settings'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-settings.profile','right');
        const pd_0:any = ((<any>co.setProfile('custom_household')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-cog fa-2x'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn btn-open-info'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-affordability-data-mobile','bottom')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-info fa-2x'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),168,'div',[[
        'class',
        'map-affordability-data-mobile pageslide bottom'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),165,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-right'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-affordability-data-mobile','bottom')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-close fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'current-state census-track-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),152,'div',[[
        'class',
        'map-affordability-data-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),143,'div',[[
        'class',
        'costs-info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'profileDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'income'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostOfLivingComponent_22)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostOfLivingComponent_23)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'income_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Taxes'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'taxes_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['House rent'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'house_rent_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Food costs'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'food_costs_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Utilities'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'utilities_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Child care'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'child_care_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Healthcare'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'health_care_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Transportation'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'transportation_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'result'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Money left'])),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),6,'span',[[
        'id',
        'play_money_value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import4.ɵdid(278528,(null as any),0,import5.NgClass,[
      import4.IterableDiffers,
      import4.KeyValueDiffers,
      import4.ElementRef,
      import4.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵpod([
      'item-value',
      'positive'
    ]
    ),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'meta-info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-how-to-use'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-how-to-use','bottom')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                How to use this tool\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'map-how-to-use pageslide bottom'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),27,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-right'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-how-to-use','bottom')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-times fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            How to use this tool\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'instructions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              The breakdown at right shows income and expenses estimated for each demographic at the selected location.\n            '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              Explore cost of living across different income, profession and family compositions. Select a predefined demographic or enter yours above.\n            '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              Disposable income or money left is illustrated by colors in the map: green areas mean that you can afford to live there based on the income and expense estimates, whereas red areas show areas are not affordable (i.e. expenses are higher than income).\n            '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),4,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              Income data comes from the BLS for 800+ professions accross 1200+ geographical areas. Taxes are estimated accounting for both federal and state laws. Rental prices are estimated at the neighbourhood level (12,000+ census tracts). '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Full methodology and presentation here'])),
    (l()(),import4.ɵted((null as any),['.\n            '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'map-location-selector pageslide left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-left'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-location-selector','top')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-chevron-left fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            Select location\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'top-cities'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_24)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'map-profile-selector pageslide left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-left'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-profile-selector','left')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-chevron-left fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            Select profile\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'profiles'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostOfLivingComponent_25)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import4.ɵppd(1),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-profile-selector','left');
        co.toggleScreen('.map-settings.profile','right');
        const pd_0:any = ((<any>co.setProfile('custom_household')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              Custom Household\n            '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),77,'div',[[
        'class',
        'map-settings profile pageslide right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),74,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-left'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.profile','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-chevron-left fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            Custom Household\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),63,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Your occupation'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'option-value'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        co.professionTypeToSelect = 'first';
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.profession','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n              '
    ]
    )),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_26)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'next'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-chevron-right'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Your spouse occupation'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'option-value'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        co.professionTypeToSelect = 'second';
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.profession','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n              '
    ]
    )),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_27)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'next'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-chevron-right'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Family'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[
      [
        'class',
        'option-value'
      ]
      ,
      [
        'i18n',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.family','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      ' '
    ]
    )),
    (l()(),import4.ɵeld(0,(null as any),(null as any),5,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      import4.ɵdid(16384,(null as any),0,import5.NgSwitch,([] as any[]),{ngSwitch: [
        0,
        'ngSwitch'
      ]
    },(null as any)),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_28)),
    import4.ɵdid(278528,(null as any),0,import5.NgSwitchCase,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import5.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_29)),
    import4.ɵdid(16384,(null as any),0,import5.NgSwitchDefault,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import5.NgSwitch
    ]
    ,(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),[' in house\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'next'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-chevron-right'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      'Rent (',
      ' sq.ft.)'
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'option-value slider-setting no-border'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),5,'nouislider',[[
        'style',
        'margin: 10px 10px 0px 10px !important;'
      ]
    ],[
      [
        2,
        'ng2-nouislider',
        (null as any)
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'slide'
      ]
      ,
      [
        (null as any),
        'end'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.profile.houseRentArea = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('slide' === en)) {
        const pd_1:any = ((<any>co.setSliderTooltip($event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('end' === en)) {
        const pd_2:any = ((<any>co.sliderEnd()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import7.View_NouisliderComponent_0,import7.RenderType_NouisliderComponent)),
    import4.ɵdid(638976,(null as any),0,import8.NouisliderComponent,[import4.ElementRef],{
      connect: [
        0,
        'connect'
      ]
      ,
      min: [
        1,
        'min'
      ]
      ,
      max: [
        2,
        'max'
      ]
      ,
      step: [
        3,
        'step'
      ]
      ,
      ngModel: [
        4,
        'ngModel'
      ]

    }
    ,{
      slide: 'slide',
      end: 'end'
    }
    ),
    import4.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import8.NouisliderComponent]),
    import4.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import4.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import4.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Food plan'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'option-value'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.food','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n              '
    ]
    )),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'next'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-chevron-right'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),61,'div',[[
        'class',
        'map-settings profession pageslide right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),58,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-left'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.profession','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-chevron-left fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_30)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_31)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),41,'div',[[
        'class',
        'professions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_32)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-settings.profession','right');
        const pd_0:any = ((<any>co.setProfession(co.specialProfessions.AVERAGE_INCOME)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n            '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_33)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        co.toggleScreen('.map-settings.profession','right');
        const pd_0:any = ((<any>co.setProfession(co.specialProfessions.MINIMUM_WAGE)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '\n              ',
      '\n            '
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n\n\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_34)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),23,'div',[[
        'class',
        'option custom-income'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'form-inline'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                ... or enter income $\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'col-10'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'custom-income-input form-control'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'col-2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_36)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                    '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_37)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'error custom-income-error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'map-settings family pageslide right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-left'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.family','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-chevron-left fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_38)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            Family\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'family'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_39)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'map-settings food pageslide right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'am-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'btn-left'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CostOfLivingComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleScreen('.map-settings.food','right')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-chevron-left fa-lg'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            Select food plan\n          '])),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'plans'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostOfLivingComponent_46)),
    import4.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import4.ViewContainerRef,
      import4.TemplateRef,
      import4.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n    '])),
    (l()(),import4.ɵted((null as any),['\n\n    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),33,'div',[[
        'class',
        'map-legend'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'map-legend-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),17,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#00772e;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#2e9b42;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#77d460;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#acfe76;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#FED976;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#FD8D3C;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#E31A1C;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'li',[[
        'style',
        'background-color:#800026;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'more-affordable-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['More'])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['affordable'])),
    (l()(),import4.ɵted((null as any),['\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'less-affordable-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Less'])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['affordable'])),
    (l()(),import4.ɵted((null as any),['\n      '])),
    (l()(),import4.ɵted((null as any),['\n    '])),
    (l()(),import4.ɵted((null as any),['\n\n    '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),189,'div',[[
        'class',
        'map-affordability-data'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),186,'div',[[
        'class',
        'map-affordability-data-content hidden-md-down'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n        '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),147,'div',[[
        'class',
        'costs-info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'current-state census-track-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'profileDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'income'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostOfLivingComponent_47)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostOfLivingComponent_48)),
    import4.ɵdid(16384,(null as any),0,import5.NgIf,[
      import4.ViewContainerRef,
      import4.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'income_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Taxes'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'taxes_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['House rent'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'house_rent_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Food costs'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'food_costs_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Utilities'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'utilities_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Child care'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'child_care_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Healthcare'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'health_care_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'expenses'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import4.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    (l()(),import4.ɵted((null as any),['Transportation'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),3,'span',[
      [
        'class',
        'item-value'
      ]
      ,
      [
        'id',
        'transportation_value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'result'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Money left'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),6,'span',[[
        'id',
        'play_money_value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import4.ɵdid(278528,(null as any),0,import5.NgClass,[
      import4.IterableDiffers,
      import4.KeyValueDiffers,
      import4.ElementRef,
      import4.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵpod([
      'item-value',
      'positive'
    ]
    ),
    (l()(),import4.ɵted((null as any),[
      '',
      '/yr'
    ]
    )),
    import4.ɵpid(131072,import5.AsyncPipe,[import4.ChangeDetectorRef]),
    import4.ɵppd(4),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'clearfix'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n\n        '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),34,'div',[
      [
        'class',
        'meta-info'
      ]
      ,
      [
        'style',
        'display:none;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n\n          '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),31,'div',[[
        'class',
        'morph-button morph-button-modal morph-button-modal-1 morph-button-fixed'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'button',[[
        'type',
        'button'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['How to use this tool'])),
    (l()(),import4.ɵted((null as any),['\n            '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),25,'div',[[
        'class',
        'morph-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),22,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'content-style-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'icon icon-close'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Close the dialog'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['How to use this tool'])),
    (l()(),import4.ɵted((null as any),['\n                  '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                    The breakdown at right shows income and expenses estimated for each demographic at the selected location.\n                  '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  Explore cost of living across different income, profession and family compositions. Select a predefined demographic or enter yours above.\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  Disposable income or money left is illustrated by colors in the map: green areas mean that you can afford to live there based on the income and expense estimates, whereas red areas show areas are not affordable (i.e. expenses are higher than income).\n                '])),
    (l()(),import4.ɵeld(0,(null as any),(null as any),4,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n                  Income data comes from the BLS for 800+ professions accross 1200+ geographical areas. Taxes are estimated accounting for both federal and state laws. Rental prices are estimated at the neighbourhood level (12,000+ census tracts). '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['Full methodology and presentation here'])),
    (l()(),import4.ɵted((null as any),['.\n                '])),
    (l()(),import4.ɵted((null as any),['\n                '])),
    (l()(),import4.ɵted((null as any),['\n              '])),
    (l()(),import4.ɵted((null as any),['\n            '])),
    (l()(),import4.ɵted((null as any),['\n          '])),
    (l()(),import4.ɵted((null as any),['\n        '])),
    (l()(),import4.ɵted((null as any),['\n\n      '])),
    (l()(),import4.ɵted((null as any),['\n\n    '])),
    (l()(),import4.ɵted((null as any),['\n\n  '])),
    (l()(),import4.ɵted((null as any),['\n'])),
    (l()(),import4.ɵted((null as any),['\n\n'])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'map-tooltip-box'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'span',[[
        'class',
        'region-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'span',[[
        'class',
        'description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n  '])),
      (l()(),import4.ɵeld(0,(null as any),(null as any),0,'span',[[
        'class',
        'census-tract-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import4.ɵted((null as any),['\n'])),
    (l()(),import4.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import10.CostOfLivingComponent = v.component;
    const currVal_5:any = co.topCities;
    ck(v,51,0,currVal_5);
    const currVal_7:any = (co.profile.id == 'custom_household');
    ck(v,108,0,currVal_7);
    var tmp_9_0:any = (null as any);
    const currVal_9:any = ((((tmp_9_0 = import4.ɵunv(v,150,0,import4.ɵnov(v,151).transform(co.censusTract))) == null)? (null as any): tmp_9_0.properties.incomeSourceLink) != (null as any));
    ck(v,150,0,currVal_9);
    var tmp_10_0:any = (null as any);
    const currVal_10:any = ((((tmp_10_0 = import4.ɵunv(v,154,0,import4.ɵnov(v,155).transform(co.censusTract))) == null)? (null as any): tmp_10_0.properties.incomeSourceLink) == (null as any));
    ck(v,154,0,currVal_10);
    var tmp_26_0:any = (null as any);
    const currVal_26:any = ck(v,278,0,true,((((tmp_26_0 = import4.ɵunv(v,276,0,import4.ɵnov(v,277).transform(co.censusTract))) == null)? (null as any): tmp_26_0.properties.moneyLeft) >= 0));
    ck(v,276,0,currVal_26);
    const currVal_28:any = co.topCities;
    ck(v,345,0,currVal_28);
    const currVal_29:any = import4.ɵunv(v,366,0,ck(v,367,0,import4.ɵnov(v,1),co.profiles));
    ck(v,366,0,currVal_29);
    const currVal_31:any = (co.profile.firstProfession.code === co.specialProfessions.FIRST_CUSTOM_INCOME.code);
    ck(v,396,0,currVal_31);
    const currVal_33:any = (co.profile.secondProfession.code === co.specialProfessions.SECOND_CUSTOM_INCOME.code);
    ck(v,408,0,currVal_33);
    const currVal_35:any = co.profile.householdMembers.length;
    ck(v,420,0,currVal_35);
    const currVal_36:any = '=1';
    ck(v,422,0,currVal_36);
    const currVal_46:any = true;
    const currVal_47:any = co.slider.min;
    const currVal_48:any = co.slider.max;
    const currVal_49:any = 1;
    const currVal_50:any = co.profile.houseRentArea;
    ck(v,436,0,currVal_46,currVal_47,currVal_48,currVal_49,currVal_50);
    const currVal_51:any = co.profile.houseRentArea;
    ck(v,438,0,currVal_51);
    const currVal_53:any = (co.professionTypeToSelect === 'first');
    ck(v,468,0,currVal_53);
    const currVal_54:any = (co.professionTypeToSelect === 'second');
    ck(v,471,0,currVal_54);
    const currVal_55:any = (co.professionTypeToSelect === 'second');
    ck(v,477,0,currVal_55);
    const currVal_57:any = (co.professionTypeToSelect === 'second');
    ck(v,483,0,currVal_57);
    const currVal_59:any = co.professions;
    ck(v,489,0,currVal_59);
    const currVal_60:any = (co.professionTypeToSelect === 'first');
    ck(v,505,0,currVal_60);
    const currVal_61:any = (co.professionTypeToSelect === 'second');
    ck(v,508,0,currVal_61);
    const currVal_62:any = (co.profile.householdMembers.length < 6);
    ck(v,530,0,currVal_62);
    const currVal_63:any = co.profile.householdMembers;
    ck(v,538,0,currVal_63);
    const currVal_64:any = co.foodPlans;
    ck(v,559,0,currVal_64);
    var tmp_67_0:any = (null as any);
    const currVal_67:any = ((((tmp_67_0 = import4.ɵunv(v,616,0,import4.ɵnov(v,617).transform(co.censusTract))) == null)? (null as any): tmp_67_0.properties.incomeSourceLink) != (null as any));
    ck(v,616,0,currVal_67);
    var tmp_68_0:any = (null as any);
    const currVal_68:any = ((((tmp_68_0 = import4.ɵunv(v,620,0,import4.ɵnov(v,621).transform(co.censusTract))) == null)? (null as any): tmp_68_0.properties.incomeSourceLink) == (null as any));
    ck(v,620,0,currVal_68);
    var tmp_84_0:any = (null as any);
    const currVal_84:any = ck(v,744,0,true,((((tmp_84_0 = import4.ɵunv(v,742,0,import4.ɵnov(v,743).transform(co.censusTract))) == null)? (null as any): tmp_84_0.properties.moneyLeft) >= 0));
    ck(v,742,0,currVal_84);
  },(ck,v) => {
    var co:import10.CostOfLivingComponent = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import4.ɵunv(v,15,0,import4.ɵnov(v,16).transform(co.city))) == null)? (null as any): tmp_0_0.name);
    var tmp_1_0:any = (null as any);
    const currVal_1:any = (((tmp_1_0 = import4.ɵunv(v,15,1,import4.ɵnov(v,17).transform(co.city))) == null)? (null as any): tmp_1_0.state.code);
    ck(v,15,0,currVal_0,currVal_1);
    const currVal_2:any = co.profile.name;
    ck(v,20,0,currVal_2);
    var tmp_3_0:any = (null as any);
    const currVal_3:any = (((tmp_3_0 = import4.ɵunv(v,42,0,import4.ɵnov(v,43).transform(co.city))) == null)? (null as any): tmp_3_0.name);
    var tmp_4_0:any = (null as any);
    const currVal_4:any = (((tmp_4_0 = import4.ɵunv(v,42,1,import4.ɵnov(v,44).transform(co.city))) == null)? (null as any): tmp_4_0.state.code);
    ck(v,42,0,currVal_3,currVal_4);
    const currVal_6:any = co.profile.name;
    ck(v,62,0,currVal_6);
    const currVal_8:any = co.profile.description;
    ck(v,145,0,currVal_8);
    var tmp_11_0:any = (null as any);
    const currVal_11:any = import4.ɵunv(v,158,0,ck(v,160,0,import4.ɵnov(v,0),(((tmp_11_0 = import4.ɵunv(v,158,0,import4.ɵnov(v,159).transform(co.censusTract))) == null)? (null as any): tmp_11_0.properties.income),'USD',true,'1.0'));
    ck(v,158,0,currVal_11);
    var tmp_12_0:any = (null as any);
    const currVal_12:any = import4.ɵinlineInterpolate(1,'',(((tmp_12_0 = import4.ɵunv(v,168,0,import4.ɵnov(v,169).transform(co.censusTract))) == null)? (null as any): tmp_12_0.properties.taxesSourceLink),'');
    ck(v,168,0,currVal_12);
    var tmp_13_0:any = (null as any);
    const currVal_13:any = import4.ɵunv(v,173,0,ck(v,175,0,import4.ɵnov(v,0),(((tmp_13_0 = import4.ɵunv(v,173,0,import4.ɵnov(v,174).transform(co.censusTract))) == null)? (null as any): tmp_13_0.properties.taxes),'USD',true,'1.0'));
    ck(v,173,0,currVal_13);
    var tmp_14_0:any = (null as any);
    const currVal_14:any = import4.ɵinlineInterpolate(1,'',(((tmp_14_0 = import4.ɵunv(v,183,0,import4.ɵnov(v,184).transform(co.censusTract))) == null)? (null as any): tmp_14_0.properties.houseRentSourceLink),'');
    ck(v,183,0,currVal_14);
    var tmp_15_0:any = (null as any);
    const currVal_15:any = import4.ɵunv(v,188,0,ck(v,190,0,import4.ɵnov(v,0),(((tmp_15_0 = import4.ɵunv(v,188,0,import4.ɵnov(v,189).transform(co.censusTract))) == null)? (null as any): tmp_15_0.properties.houseRentCosts),'USD',true,'1.0'));
    ck(v,188,0,currVal_15);
    var tmp_16_0:any = (null as any);
    const currVal_16:any = import4.ɵinlineInterpolate(1,'',(((tmp_16_0 = import4.ɵunv(v,198,0,import4.ɵnov(v,199).transform(co.censusTract))) == null)? (null as any): tmp_16_0.properties.foodCostsSourceLink),'');
    ck(v,198,0,currVal_16);
    var tmp_17_0:any = (null as any);
    const currVal_17:any = import4.ɵunv(v,203,0,ck(v,205,0,import4.ɵnov(v,0),(((tmp_17_0 = import4.ɵunv(v,203,0,import4.ɵnov(v,204).transform(co.censusTract))) == null)? (null as any): tmp_17_0.properties.foodCosts),'USD',true,'1.0'));
    ck(v,203,0,currVal_17);
    var tmp_18_0:any = (null as any);
    const currVal_18:any = import4.ɵinlineInterpolate(1,'',(((tmp_18_0 = import4.ɵunv(v,213,0,import4.ɵnov(v,214).transform(co.censusTract))) == null)? (null as any): tmp_18_0.properties.utilitiesCostsSourceLink),'');
    ck(v,213,0,currVal_18);
    var tmp_19_0:any = (null as any);
    const currVal_19:any = import4.ɵunv(v,218,0,ck(v,220,0,import4.ɵnov(v,0),(((tmp_19_0 = import4.ɵunv(v,218,0,import4.ɵnov(v,219).transform(co.censusTract))) == null)? (null as any): tmp_19_0.properties.utilitiesCosts),'USD',true,'1.0'));
    ck(v,218,0,currVal_19);
    var tmp_20_0:any = (null as any);
    const currVal_20:any = import4.ɵinlineInterpolate(1,'',(((tmp_20_0 = import4.ɵunv(v,228,0,import4.ɵnov(v,229).transform(co.censusTract))) == null)? (null as any): tmp_20_0.properties.childCareCostsSourceLink),'');
    ck(v,228,0,currVal_20);
    var tmp_21_0:any = (null as any);
    const currVal_21:any = import4.ɵunv(v,233,0,ck(v,235,0,import4.ɵnov(v,0),(((tmp_21_0 = import4.ɵunv(v,233,0,import4.ɵnov(v,234).transform(co.censusTract))) == null)? (null as any): tmp_21_0.properties.childCareCosts),'USD',true,'1.0'));
    ck(v,233,0,currVal_21);
    var tmp_22_0:any = (null as any);
    const currVal_22:any = import4.ɵinlineInterpolate(1,'',(((tmp_22_0 = import4.ɵunv(v,243,0,import4.ɵnov(v,244).transform(co.censusTract))) == null)? (null as any): tmp_22_0.properties.healthCareCostsSourceLink),'');
    ck(v,243,0,currVal_22);
    var tmp_23_0:any = (null as any);
    const currVal_23:any = import4.ɵunv(v,248,0,ck(v,250,0,import4.ɵnov(v,0),(((tmp_23_0 = import4.ɵunv(v,248,0,import4.ɵnov(v,249).transform(co.censusTract))) == null)? (null as any): tmp_23_0.properties.healthCareCosts),'USD',true,'1.0'));
    ck(v,248,0,currVal_23);
    var tmp_24_0:any = (null as any);
    const currVal_24:any = import4.ɵinlineInterpolate(1,'',(((tmp_24_0 = import4.ɵunv(v,258,0,import4.ɵnov(v,259).transform(co.censusTract))) == null)? (null as any): tmp_24_0.properties.transportationCostsSourceLink),'');
    ck(v,258,0,currVal_24);
    var tmp_25_0:any = (null as any);
    const currVal_25:any = import4.ɵunv(v,263,0,ck(v,265,0,import4.ɵnov(v,0),(((tmp_25_0 = import4.ɵunv(v,263,0,import4.ɵnov(v,264).transform(co.censusTract))) == null)? (null as any): tmp_25_0.properties.transportationCosts),'USD',true,'1.0'));
    ck(v,263,0,currVal_25);
    var tmp_27_0:any = (null as any);
    const currVal_27:any = import4.ɵunv(v,279,0,ck(v,281,0,import4.ɵnov(v,0),(((tmp_27_0 = import4.ɵunv(v,279,0,import4.ɵnov(v,280).transform(co.censusTract))) == null)? (null as any): tmp_27_0.properties.moneyLeft),'USD',true,'1.0'));
    ck(v,279,0,currVal_27);
    const currVal_30:any = co.profile.firstProfession.name;
    ck(v,394,0,currVal_30);
    const currVal_32:any = co.profile.secondProfession.name;
    ck(v,406,0,currVal_32);
    const currVal_34:any = co.profile.householdMembers.length;
    ck(v,418,0,currVal_34);
    const currVal_37:any = co.slider.value;
    ck(v,431,0,currVal_37);
    const currVal_38:any = true;
    const currVal_39:any = import4.ɵnov(v,440).ngClassUntouched;
    const currVal_40:any = import4.ɵnov(v,440).ngClassTouched;
    const currVal_41:any = import4.ɵnov(v,440).ngClassPristine;
    const currVal_42:any = import4.ɵnov(v,440).ngClassDirty;
    const currVal_43:any = import4.ɵnov(v,440).ngClassValid;
    const currVal_44:any = import4.ɵnov(v,440).ngClassInvalid;
    const currVal_45:any = import4.ɵnov(v,440).ngClassPending;
    ck(v,435,0,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,currVal_45);
    const currVal_52:any = co.profile.foodPlan.name;
    ck(v,447,0,currVal_52);
    const currVal_56:any = co.specialProfessions.AVERAGE_INCOME.name;
    ck(v,480,0,currVal_56);
    const currVal_58:any = co.specialProfessions.MINIMUM_WAGE.name;
    ck(v,486,0,currVal_58);
    var tmp_65_0:any = (null as any);
    const currVal_65:any = (((tmp_65_0 = import4.ɵunv(v,607,0,import4.ɵnov(v,608).transform(co.censusTract))) == null)? (null as any): tmp_65_0.properties.name);
    ck(v,607,0,currVal_65);
    const currVal_66:any = co.profile.description;
    ck(v,611,0,currVal_66);
    var tmp_69_0:any = (null as any);
    const currVal_69:any = import4.ɵunv(v,624,0,ck(v,626,0,import4.ɵnov(v,0),(((tmp_69_0 = import4.ɵunv(v,624,0,import4.ɵnov(v,625).transform(co.censusTract))) == null)? (null as any): tmp_69_0.properties.income),'USD',true,'1.0'));
    ck(v,624,0,currVal_69);
    var tmp_70_0:any = (null as any);
    const currVal_70:any = import4.ɵinlineInterpolate(1,'',(((tmp_70_0 = import4.ɵunv(v,634,0,import4.ɵnov(v,635).transform(co.censusTract))) == null)? (null as any): tmp_70_0.properties.taxesSourceLink),'');
    ck(v,634,0,currVal_70);
    var tmp_71_0:any = (null as any);
    const currVal_71:any = import4.ɵunv(v,639,0,ck(v,641,0,import4.ɵnov(v,0),(((tmp_71_0 = import4.ɵunv(v,639,0,import4.ɵnov(v,640).transform(co.censusTract))) == null)? (null as any): tmp_71_0.properties.taxes),'USD',true,'1.0'));
    ck(v,639,0,currVal_71);
    var tmp_72_0:any = (null as any);
    const currVal_72:any = import4.ɵinlineInterpolate(1,'',(((tmp_72_0 = import4.ɵunv(v,649,0,import4.ɵnov(v,650).transform(co.censusTract))) == null)? (null as any): tmp_72_0.properties.houseRentSourceLink),'');
    ck(v,649,0,currVal_72);
    var tmp_73_0:any = (null as any);
    const currVal_73:any = import4.ɵunv(v,654,0,ck(v,656,0,import4.ɵnov(v,0),(((tmp_73_0 = import4.ɵunv(v,654,0,import4.ɵnov(v,655).transform(co.censusTract))) == null)? (null as any): tmp_73_0.properties.houseRentCosts),'USD',true,'1.0'));
    ck(v,654,0,currVal_73);
    var tmp_74_0:any = (null as any);
    const currVal_74:any = import4.ɵinlineInterpolate(1,'',(((tmp_74_0 = import4.ɵunv(v,664,0,import4.ɵnov(v,665).transform(co.censusTract))) == null)? (null as any): tmp_74_0.properties.foodCostsSourceLink),'');
    ck(v,664,0,currVal_74);
    var tmp_75_0:any = (null as any);
    const currVal_75:any = import4.ɵunv(v,669,0,ck(v,671,0,import4.ɵnov(v,0),(((tmp_75_0 = import4.ɵunv(v,669,0,import4.ɵnov(v,670).transform(co.censusTract))) == null)? (null as any): tmp_75_0.properties.foodCosts),'USD',true,'1.0'));
    ck(v,669,0,currVal_75);
    var tmp_76_0:any = (null as any);
    const currVal_76:any = import4.ɵinlineInterpolate(1,'',(((tmp_76_0 = import4.ɵunv(v,679,0,import4.ɵnov(v,680).transform(co.censusTract))) == null)? (null as any): tmp_76_0.properties.utilitiesCostsSourceLink),'');
    ck(v,679,0,currVal_76);
    var tmp_77_0:any = (null as any);
    const currVal_77:any = import4.ɵunv(v,684,0,ck(v,686,0,import4.ɵnov(v,0),(((tmp_77_0 = import4.ɵunv(v,684,0,import4.ɵnov(v,685).transform(co.censusTract))) == null)? (null as any): tmp_77_0.properties.utilitiesCosts),'USD',true,'1.0'));
    ck(v,684,0,currVal_77);
    var tmp_78_0:any = (null as any);
    const currVal_78:any = import4.ɵinlineInterpolate(1,'',(((tmp_78_0 = import4.ɵunv(v,694,0,import4.ɵnov(v,695).transform(co.censusTract))) == null)? (null as any): tmp_78_0.properties.childCareCostsSourceLink),'');
    ck(v,694,0,currVal_78);
    var tmp_79_0:any = (null as any);
    const currVal_79:any = import4.ɵunv(v,699,0,ck(v,701,0,import4.ɵnov(v,0),(((tmp_79_0 = import4.ɵunv(v,699,0,import4.ɵnov(v,700).transform(co.censusTract))) == null)? (null as any): tmp_79_0.properties.childCareCosts),'USD',true,'1.0'));
    ck(v,699,0,currVal_79);
    var tmp_80_0:any = (null as any);
    const currVal_80:any = import4.ɵinlineInterpolate(1,'',(((tmp_80_0 = import4.ɵunv(v,709,0,import4.ɵnov(v,710).transform(co.censusTract))) == null)? (null as any): tmp_80_0.properties.healthCareCostsSourceLink),'');
    ck(v,709,0,currVal_80);
    var tmp_81_0:any = (null as any);
    const currVal_81:any = import4.ɵunv(v,714,0,ck(v,716,0,import4.ɵnov(v,0),(((tmp_81_0 = import4.ɵunv(v,714,0,import4.ɵnov(v,715).transform(co.censusTract))) == null)? (null as any): tmp_81_0.properties.healthCareCosts),'USD',true,'1.0'));
    ck(v,714,0,currVal_81);
    var tmp_82_0:any = (null as any);
    const currVal_82:any = import4.ɵinlineInterpolate(1,'',(((tmp_82_0 = import4.ɵunv(v,724,0,import4.ɵnov(v,725).transform(co.censusTract))) == null)? (null as any): tmp_82_0.properties.transportationCostsSourceLink),'');
    ck(v,724,0,currVal_82);
    var tmp_83_0:any = (null as any);
    const currVal_83:any = import4.ɵunv(v,729,0,ck(v,731,0,import4.ɵnov(v,0),(((tmp_83_0 = import4.ɵunv(v,729,0,import4.ɵnov(v,730).transform(co.censusTract))) == null)? (null as any): tmp_83_0.properties.transportationCosts),'USD',true,'1.0'));
    ck(v,729,0,currVal_83);
    var tmp_85_0:any = (null as any);
    const currVal_85:any = import4.ɵunv(v,745,0,ck(v,747,0,import4.ɵnov(v,0),(((tmp_85_0 = import4.ɵunv(v,745,0,import4.ɵnov(v,746).transform(co.censusTract))) == null)? (null as any): tmp_85_0.properties.moneyLeft),'USD',true,'1.0'));
    ck(v,745,0,currVal_85);
  });
}
function View_CostOfLivingComponent_Host_0(l:any):import4.ɵViewDefinition {
  return import4.ɵvid(0,[
    (l()(),import4.ɵeld(0,(null as any),(null as any),1,'costOfLivingComponent',([] as any[]),(null as any),(null as any),(null as any),View_CostOfLivingComponent_0,RenderType_CostOfLivingComponent)),
    import4.ɵdid(4243456,(null as any),0,import10.CostOfLivingComponent,[
      'isBrowser',
      import11.ActivatedRoute,
      import12.TransferState,
      import13.CityUtils,
      import14.MapUrlUtils,
      import15.ProfessionCategoriesUtils,
      import16.AffordabilityUtils,
      import17.CensusTractsTilesUtils
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CostOfLivingComponentNgFactory:import4.ComponentFactory<import10.CostOfLivingComponent> = import4.ɵccf('costOfLivingComponent',import10.CostOfLivingComponent,View_CostOfLivingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/cost-of-living/cost-of-living.component.ngfactory.ts